import { Calendar, MapPin, Users } from "lucide-react";

const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return {
      day: d.getDate().toString().padStart(2, "0"),
      month: d.toLocaleString("en-US", { month: "short" }).toUpperCase(),
      year: d.getFullYear(),
      time: d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }),
    };
  } catch {
    return { day: "--", month: "---", year: "----", time: "--:--" };
  }
};

export const EventCard = ({ event, onRsvp, index = 0 }) => {
  const date = formatDate(event.event_date);

  return (
    <article
      data-testid={`event-card-${event.id}`}
      className="rounded-2xl overflow-hidden bg-zinc-900/60 border border-zinc-800 hover:border-zinc-700 grid grid-cols-1 md:grid-cols-[120px_1fr] zl-rise transition-all duration-200 hover:-translate-y-0.5"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      {/* Date block */}
      <div className="bg-gradient-to-br from-[#FF5612] to-[#FF3300] text-white p-5 flex md:flex-col items-center justify-center gap-2 md:gap-0">
        <div className="font-display font-extrabold text-4xl md:text-5xl leading-none">
          {date.day}
        </div>
        <div className="text-center md:mt-2">
          <div className="text-xs font-bold tracking-[0.18em] uppercase">{date.month}</div>
          <div className="text-[10px] text-white/70 mt-0.5">{date.year}</div>
          <div className="text-[10px] text-white/90 mt-1.5">{date.time}</div>
        </div>
      </div>

      {/* Body */}
      <div className="p-5 md:p-6 flex flex-col md:flex-row gap-5">
        {event.image_url && (
          <div className="md:w-36 h-32 md:h-auto shrink-0 rounded-xl overflow-hidden bg-zinc-800">
            <img
              src={event.image_url}
              alt={event.title}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        )}

        <div className="flex-1 min-w-0 flex flex-col">
          <h3 className="font-display font-bold text-lg md:text-xl tracking-tight leading-tight text-white mb-2">
            {event.title}
          </h3>

          <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-zinc-400 mb-3">
            <div className="inline-flex items-center gap-1.5">
              <MapPin className="w-3.5 h-3.5 text-[#FF5612]" />
              <span className="font-medium text-zinc-200">{event.store_name}</span>
              <span className="text-zinc-600">·</span>
              <span>{event.store_city}</span>
            </div>
            {event.capacity && (
              <div className="inline-flex items-center gap-1.5">
                <Users className="w-3.5 h-3.5" />
                <span>{event.capacity} seats</span>
              </div>
            )}
          </div>

          <p className="text-sm text-zinc-400 leading-relaxed mb-4 flex-1">
            {event.description}
          </p>

          <div className="flex items-center justify-between gap-3 flex-wrap">
            <div className="inline-flex items-center gap-1.5 text-xs text-zinc-300">
              <Calendar className="w-3.5 h-3.5" />
              <span>{date.day} {date.month} · {date.time}</span>
            </div>
            <button
              onClick={() => onRsvp && onRsvp(event)}
              data-testid={`rsvp-btn-${event.id}`}
              className="bg-[#FF5612] hover:bg-[#FF6B2B] text-white rounded-full px-5 py-2.5 text-xs font-bold transition-colors"
            >
              RSVP Now →
            </button>
          </div>
        </div>
      </div>
    </article>
  );
};

export default EventCard;
